import { useTheme } from "../../../framework/theme/mantine-passthroughs.js";
import { rem } from "../../../framework/theme/util/misc.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconFullscreen.tsx
/**
* Confirmed from Figma as the real "enter full screen" glyph (four corner brackets) — a
* stroke-based icon, unlike every other Material Symbols icon in this set, which are filled
* paths. Doesn't reuse the shared `Icon` wrapper (which forces `fill`) since this icon's color
* comes from `stroke`; applies the same `getIconColor` resolution directly instead.
*/
const FullscreenGlyph = (props) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M12 16V14C12 13.4696 12.2107 12.9609 12.5858 12.5858C12.9609 12.2107 13.4696 12 14 12H16",
			strokeWidth: "3",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12 24V26C12 26.5304 12.2107 27.0391 12.5858 27.4142C12.9609 27.7893 13.4696 28 14 28H16",
			strokeWidth: "3",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M24 12H26C26.5304 12 27.0391 12.2107 27.4142 12.5858C27.7893 12.9609 28 13.4696 28 14V16",
			strokeWidth: "3",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M24 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V24",
			strokeWidth: "3",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const IconFullscreen = ({ color = "currentColor", height = rem("24px"), width = rem("24px"), style = {}, "data-testid": testId = "icon" }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(FullscreenGlyph, {
		stroke: useTheme().other.getIconColor(color),
		style: {
			...style,
			height,
			width,
			minHeight: height,
			minWidth: width
		},
		"data-testid": testId,
		"aria-label": t("")
	});
};

//#endregion
export { IconFullscreen };